import React, { useState, useEffect, memo } from "react";
import { SbBlokData } from "@storyblok/react";
import { NavConfigType } from "../global";
import CustomStoryBlockComponent from "./CustomStoryBlockComponent";

interface CommonNavbarProps {
  blok: (SbBlokData & { user_type: string[]; device_type: string[] })[];
  config: NavConfigType;
  resources: {};
}

function CommonNavbar({ blok, config, resources }: CommonNavbarProps) {
  const [navWhite, setNavWhite] = useState("white-nav");

  useEffect(() => {
    if (config.transparent_navbar) {
      setNavWhite("");
      document.addEventListener("scroll", () => {
        const scrollCheck = window.scrollY;
        if (scrollCheck < 30) {
          setNavWhite("");
        } else {
          setNavWhite("white-nav");
        }
      });
    }
  }, [config.transparent_navbar]);

  const navBlokConfig = {
    ...config,
    navWhite
  };

  return (
    <ul>
      {blok?.length > 0 &&
        blok.map((nestedBlok) => {
          const nestedBlokWithUpdatedConfig = {
            ...nestedBlok,
            page_config: navBlokConfig
          };

          return (
            <li key={nestedBlokWithUpdatedConfig._uid} className="list-none grow">
              <CustomStoryBlockComponent resources={resources} blok={nestedBlokWithUpdatedConfig} />
            </li>
          );
        })}
    </ul>
  );
}

export default memo(CommonNavbar);
